<template>
<div>

  <section class="mb-4">
    <div class="row pt-3">
      <div class="col-8">
        <div class="text_11 text_branco text_bold">Saldo Total:</div>
        <div class="text_23 text_verde text_bold">R$ {{ formatarMoeda(parseFloat(balance_convidado)) }}</div>
      </div>
      <div class="col-4" v-if="balance_convidado > 0">
        <router-link to="/conta/convite/transferir" class="btn btn-outline-success w-100 btn-sm mb-3 p-2">
        <img :src='"../../assets/image/transfer.svg"' alt="Responsive image" width="18px"> &nbsp; Transferir
        </router-link>
      </div>
    </div>

    <div class="row pt-2 pb-2">
      <div class="col-1 text_10 text_bold text_amarelo pt-2" @click="copy()">
        <img :src='"../../assets/image/copy.svg"' alt="Responsive image" width="18px" style="cursor: pointer;"> Copiar
      </div>
      <div class="col-9 text_10 text_bold text_branco"> O SEU LINK DE CONVITE É:
        <input type="text" ref="copiar" v-model="link_convite" readonly>
      </div>
    </div>
  </section>

  <section class="mb-3">
    <div class="row">
      <!-- <div class="col-4">
        <router-link to="/conta/convite/resumo" class="btn w-100 btn-sm mb-3 text_11"
        v-bind:class="[btn == 1?'btn-success':'btn-outline-secondary']">Resumo</router-link>
      </div> -->
      <div class="col-6">
        <router-link to="/conta/convite/historico" class="btn w-100 btn-sm mb-3 text_11 text_bold"
        v-bind:class="[btn == 2?'btn-success':'btn-outline-secondary']">Convites</router-link>
      </div>
      <div class="col-6">
        <router-link to="/conta/convite/ganho" class="btn w-100 btn-sm mb-3 text_11 text_bold"
        v-bind:class="[btn == 3?'btn-success':'btn-outline-secondary']">Ganhos</router-link>
      </div>
    </div>
  </section> 

</div>
</template>

<script>

import axios from 'axios';
import ccMenu from '../layout/menu.vue'
import ccContaTopo from '../conta/topo.vue'
import {TheMask} from 'vue-the-mask';

export default {

  props: {
    btn: 0,
  },

  data () {
    return {
      base_url_api: process.env.BASE_URL_API,
      base_local: process.env.BASE_LOCAL,
      user: {},
      loading: true,
      errors: [],

      link_convite: null,
      balance_convidado: null,
      token: null,
    }
  },

  components: {ccMenu, TheMask, ccContaTopo},

  created()
  {

    // console.log(this.balance_convidado)

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null){ this.user = {} }else{ this.user = a }

    this.token = this.user.access_token

    this.get_user_completo()
  },

  methods: {

    get_user_completo(){
      this.loading = true;
      var header = {'headers': {'x-access-token': this.token, }};
      axios.get(this.base_url_api+'user/completo', header)
      .then(response => {

        this.user = response.data.resp
        this.link_convite = process.env.BASE_LOCAL+'#/cadastro/'+this.user.link_convite
        this.balance_convidado = this.user.balance_convidado

        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e)
        this.expluse_para_login()
      });
    },

    copy(){
      var copyTextarea = this.$refs.copiar
      copyTextarea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'sim!' : 'não!';
        alert('Copiado com sucesso.');
      } catch (err) {
        alert('Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.');
      }
    },

  }

}
</script>

<style scoped>

input{
  border: none;
  background-color: transparent;
  color: yellow;
  width: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/conta/convite_topo.vue